<template>
	<div class="job-evaluation-level">
		<div>
			<div>
				<label>Rol</label>
				<v-select
					solo
					class="custom-select"
					item-text="name"
					item-value="id"
					:items="levelInfo.role.data"
					v-model="jobCopied.role"
					@change="onSelectChange"
				></v-select>
			</div>
			<div>
				<label>Titulación Elegible</label>
				<v-select
					solo
					class="custom-select"
					item-text="name"
					item-value="id"
					:items="levelInfo.title.data"
					v-model="jobCopied.title"
					@change="onSelectChange"
				></v-select>
			</div>
			<div>
				<label>Exp. Profesional Elegible</label>
				<v-select
					solo
					class="custom-select"
					item-text="name"
					item-value="id"
					:items="levelInfo.experience.data"
					v-model="jobCopied.experience"
					@change="onSelectChange"
				></v-select>
			</div>
		</div>
	</div>
</template>

<script>
import { clone } from 'ramda';

export default {
	name: 'guideline-job-level-selector',
	props: {
		levelInfo: {
			default: () => ({}),
		},
		selectedJob: {
			default: () => ({}),
		},
	},
	watch: {
		selectedJob: {
			deep: true,
			handler(val) {
				this.jobCopied = clone(val);
			},
		},
	},
	data() {
		return {
			jobCopied: {
				role: {},
				title: {},
				experience: {},
			},
		};
	},
	methods: {
		onSelectChange() {
			this.$emit('selectedJobDataChanged', clone(this.jobCopied));
		},
	},
};
</script>

<style lang="scss" scoped>
.job-evaluation-level {
	border-top: solid 1px var(--app-color-gray);
	padding: 20px 40px;
	label {
		color: var(--app-color-info);
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/job-info-edition/guideline-job-level-selector.vue